import { createStyles } from 'antd-style';

import { ThemeFont } from '../../theme';
import { FA_SELECTOR } from '../../styles/variables';

const sizeStyle = (iconSize, labelSize) => ({
  '.IconButton-Icon': {
    fontSize: iconSize,
  },
  '.IconButton-Label': {
    fontSize: labelSize,
  },
});

export const useIconButtonStyles = createStyles(() => ({
  iconButton: {
    cursor: 'pointer',
    flexDirection: 'column',
    alignItems: 'center',
    fontSize: '16px',
    display: 'inline-flex',
    '.ant-col > &': {
      display: 'flex',
    },
    '&.disabled, &.loading': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
    '.ThreeDotsSpinner': {
      marginLeft: 0,
      marginTop: '3px',
    },
    '.IconButton-Icon': {
      lineHeight: 1,
    },
    '&.size-md': {
      ...sizeStyle('1.25em', '0.5em'),
    },
    '&.size-lg': {
      ...sizeStyle('1.5em', '0.57em'),
    },
    '.IconButton-Label': {
      fontFamily: ThemeFont.FONT_FAMILY4,
      fontWeight: 'bold',
      lineHeight: 1,
    },
    [FA_SELECTOR]: {
      display: 'block',
    },
  },
  iconButtonHasLabel: {
    ...sizeStyle('1.5em', '0.57em'),
  },
}));
